import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "d-flex align-items-center position-relative me-1" }
const _hoisted_3 = { class: "card-title align-items-start flex-column" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  class: "modal fade",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  id: "kt_modal_preview",
  ref: "konfirmModalRef"
}
const _hoisted_6 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_7 = { class: "modal-content rounded" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header pb-0 border-0 justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "modal-title mb-6" }, "Konfirmasi Daftar Siswa ke PSP"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" })
  ])
], -1)
const _hoisted_9 = { class: "modal-body scroll-y px-10 px-lg-15 pt-0 pb-15" }
const _hoisted_10 = { class: "table-responsive" }
const _hoisted_11 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "min-w-125px; text-center",
      colspan: "2"
    }, " Keterangan ")
  ])
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "Jumlah Siswa", -1)
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "Harga", -1)
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "Pajak", -1)
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "Diskon", -1)
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = { class: "fw-bolder text-muted bg-light" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-end" }, "Total Harga", -1)
const _hoisted_23 = { class: "min-w-125px; text-center" }
const _hoisted_24 = { class: "modal-footer" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light",
  "data-bs-dismiss": "modal"
}, " Batal ", -1)
const _hoisted_26 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, [
        _createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.previewInvoice())),
          class: "btn btn-primary",
          disabled: _ctx.disableButton,
          type: "button"
        }, " Daftar PSP ", 8, _hoisted_4)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("table", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_13,
                    _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.items.preview.jumlahSiswa), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_15,
                    _createElementVNode("td", _hoisted_16, "Rp. " + _toDisplayString(_ctx.items.preview.harga.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1\.")), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_17,
                    _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.items.preview.pajak) + " % ", 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_19,
                    _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.items.preview.diskon) + " % ", 1)
                  ])
                ]),
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", _hoisted_21, [
                    _hoisted_22,
                    _createElementVNode("th", _hoisted_23, " Rp. " + _toDisplayString(_ctx.items.preview.total.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1\.")), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.submitAddInvoice())),
                disabled: _ctx.disableButton
              }, " Konfirmasi ", 8, _hoisted_26)
            ])
          ])
        ])
      ])
    ], 512)
  ], 64))
}